import { useState } from "react";
import StackKit from "../kit/stack";
import TypoGraphyKit from "../kit/typoGraphy";
import {Grid,SelectChangeEvent} from "@mui/material";
import BoxKit from "../kit/box";
import ImgStaticCard from "../common/imgStaticCard/imgStaticCard";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CustomSelectNormal from "../common/select/selectNormal";
import useAccountStore from "@/store/balanceStore";
import { numberSeparator } from "@/hooks/useThousandsSeparator";
import { useQuery } from "@tanstack/react-query";
import { fetchWalletBalance } from "@/api/user/home";

type ContentTitleProps = {
  setValue: (value: string) => void;
  value: string;
  handleChange: (event: SelectChangeEvent) => void;
  icon: React.ReactNode;
  title: string;
  labelInput: string;
  options?: {
    value: string;
    label?: string;
  }[];
};
/**

ContentTitle

یک کامپوننت نمایش عنوان بخش با آیکون و انتخاب موجودی کیف پول.

این کامپوننت شامل نمایش آیکون، عنوان، کارت تصویری و یک منوی انتخابی برای نوع موجودی است.

اطلاعات موجودی از useAccountStore و API واکشی موجودی کیف پول (fetchWalletBalance) دریافت می‌شوند.

ویژگی‌ها:

نمایش آیکون بخش (props icon)

نمایش عنوان بخش (props title)

انتخاب نوع موجودی با منوی کشویی (CustomSelectNormal) با مقادیر موجودی نقدی و اعتباری

کارت تصویری (ImgStaticCard) برای نمایش تصویری مرتبط با بخش

واکنش‌گرایی کامل با استفاده از StackKit و Grid برای نمایش مناسب در موبایل و دسکتاپ

@component

@param {string} value مقدار انتخاب شده در منوی کشویی

@param {(value: string) => void} setValue تابع برای بروزرسانی مقدار انتخاب شده

@param {(event: SelectChangeEvent) => void} handleChange تابع برای مدیریت تغییرات منوی انتخابی

@param {React.ReactNode} icon آیکون بخش

@param {string} title عنوان بخش

@param {string} labelInput برچسب منوی انتخابی

@param {{value: string, label?: string}[]} [options] لیست گزینه‌های منوی کشویی (اختیاری)

@returns {JSX.Element} کامپوننت نمایش عنوان بخش با منوی انتخاب موجودی
*/
export const ContentTitle = (props: ContentTitleProps) => {
  const { value, handleChange, icon, options, title, labelInput } = props;
  const [selected, setSelected] = useState("all");
  const { balance, credit, cards } = useAccountStore();
    const { data } = useQuery({
      queryKey: ["wallet-reusable-balance"],
      queryFn: fetchWalletBalance,
    });
  const dataOptionSelect = [
    {
      label: `موجودی اعتباری(ریال) : ${numberSeparator(data?.credit?.balance) ?? 0}`,
      value: "all",
    },
    {
      label: `موجودی نقدی(ریال) : ${numberSeparator(data?.balance) ?? 0}`,
      value: "cash_20card",
    },
  ];
  return (
    <StackKit className="my-3" direction={"row"} justifyContent={"space-between"} alignItems={'center'} sx={{ width: "100%"}}>
      <Grid container sx={{display:'flex',flexDirection:{md:'row',sm:'column', xs:'column'}, width: "100%",alignItems:"center" }} paddingY={2}>
        <Grid size={{sm:7,xs:12}}>
          <StackKit direction={"row"} gap={1} sx={{ width: "100%" }} alignItems={"center"} justifyContent={{xs:"center" ,sm:'center',md:"start"}}>
            <CalendarMonthOutlinedIcon style={{ color: "#fff", fontSize: "32px" }}/>
            <TypoGraphyKit variant="h5">{title}</TypoGraphyKit>
          </StackKit>
        </Grid>
        <Grid size={{sm:4,xs:12}}>
          <BoxKit>
            <StackKit className="w-full" direction={{lg:'row',md:'column-reverse',sm:'column-reverse', xs:'column-reverse'}} alignItems="center" sx={{ marginTop: "50px" }}>
              <BoxKit sx={{ minWidth: { sm: "250px", xs: "100%" }, mt: 2 }}>
                  <CustomSelectNormal label="" value={selected} onChange={(e) => setSelected(e.target.value)} options={dataOptionSelect} getOptionLabel={(item) => item.label} getOptionValue={(item) => item.value} width="100%"/>
              </BoxKit>
              <BoxKit className="w-[180px] h-[180px]" sx={{ mt: 2 }}>
                <ImgStaticCard imgSlider1="/card-out-simple-flat2.png" imgSlider2="/slide2.jpg" img1Height="180px" />
              </BoxKit>
            </StackKit>
          </BoxKit>
        </Grid>
      </Grid>
    </StackKit>
  );
};
